module.exports = __webpack_public_path__ + "assets/img/upload.f47fe918.png";